// removed by extract-text-webpack-plugin
module.exports = {"licensesContainer":"src-pages----licensesPage-module---licensesContainer---1cDQy"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/licensesPage.module.scss
// module id = 293
// module chunks = 107118379710054 111399675806999